import axios from 'axios';

const api = '/api/contract-states';

export const getAllContractStates = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};
